import { Action } from "@ngrx/store";


export const actionTypes: any = {
    SET_NOTFOUND: "Set not found",
    RESET_NOTFOUND: "Reset Not found",
    SET_SERVERERROR: "Set server error",
    RESET_SERVERERROR: "Reset server error",
    SET_BADREQUEST: "Set bad request error",
    RESET_BADREQUEST: "Reset bad request error"
};

export class SetNotFoundAction implements Action {
    type = actionTypes.SET_NOTFOUND;
}

export class ResetNotFoundAction implements Action {
    type = actionTypes.RESET_NOTFOUND;
}

export class SetServerErrorAction implements Action {
    type = actionTypes.SET_SERVERERROR;
}

export class ResetServerErrorAction implements Action {
    type = actionTypes.RESET_SERVERERROR;
}

export class SetBadRequestAction implements Action {
    type = actionTypes.SET_BADREQUEST;
}

export class ResetBadRequestAction implements Action {
    type = actionTypes.RESET_BADREQUEST;
}

export type Actions = SetNotFoundAction | ResetNotFoundAction | SetServerErrorAction | ResetServerErrorAction | SetBadRequestAction | ResetBadRequestAction;